import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "exposure-log-page" }
const _hoisted_2 = { class: "page_button_header" }
const _hoisted_3 = { class: "log_stat_item_list" }
const _hoisted_4 = { class: "log_stat_item" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "log_stat_item" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "log_stat_item" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "log_stat_item" }
const _hoisted_11 = { class: "log-descriprion" }
const _hoisted_12 = { class: "log_stat_item" }
const _hoisted_13 = { class: "log-descriprion" }
const _hoisted_14 = {
  key: 0,
  class: "loader"
}
const _hoisted_15 = {
  key: 1,
  class: "error-message"
}

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex';
import { fetchWithAuth } from '@/utils/api';
import { type ExposureLog } from '@/types';
import EditExposureLogForm from '@/components/EditExposureLogForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExposureLog',
  setup(__props) {

const store = useStore();
const apiUrl = store.getters.getApiUrl;
const token = store.state.idToken;

// Get the ID from the URL
const route = useRoute()
const log_id = Number(route.params.log_id);
const log = ref<ExposureLog | null>(null);
const showEditExposureLogForm = ref(false);
const loading = ref(false);
const fetchError = ref<string | null>(null);

const dishId = ref(Number(route.params.dish_id));

const logEdited = (newLogData: ExposureLog) => {

    if (log.value) {

        log.value.date = newLogData.date;
        log.value.taste = newLogData.taste;
        log.value.anxiety_level = newLogData.anxiety_level;
        log.value.bodys_reaction = newLogData.bodys_reaction;
        log.value.additional_notes = newLogData.additional_notes;

    }

}

const toggleEditExposureLogForm = () => {
    showEditExposureLogForm.value = !showEditExposureLogForm.value;
}

const fetchExposureLog = async (id: number) => {

    loading.value = true;
    fetchError.value = null;

    try {
        const response = await fetchWithAuth(apiUrl + `/api/logs/${id}`, {
            method: 'GET'
        }, store);
        if (response.ok) {
            const data = await response.json();
            log.value = data;
        } else {
            fetchError.value = `Failed to fetch exposure log!`;
            console.error('Failed to fetch exposure log:', await response.text());
        }
        loading.value = false;
    } catch (error) {
        loading.value = false;
        fetchError.value = `Error fetching exposure log: ${error instanceof Error ? error.message : 'Unknown error'}`;
        // Log the error to the console
        console.error('Error fetching exposure log:', error);
    }
}

onMounted(() => {
    if ( log_id ) {
        fetchExposureLog(log_id)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: `/dish/${dishId.value}`,
        class: "button back"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'chevron-left'],
            class: "fa-xs"
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Back "))
        ]),
        _: 1
      }, 8, ["to"]),
      (log.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "edit_log_button",
            onClick: toggleEditExposureLogForm
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pen'] })
          ]))
        : _createCommentVNode("", true)
    ]),
    (log.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[7] || (_cache[7] = _createElementVNode("h1", null, "Exposure Log", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "medium" }, "Date", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fal', 'calendar-days'],
                    class: "fa-lg"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(log.value.date), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "medium" }, "Anxiety Level", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fal', 'face-tired'],
                    class: "fa-lg"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(log.value.anxiety_level) + "/10", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "medium" }, "Taste", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fal', 'hat-chef'],
                    class: "fa-lg"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(log.value.taste), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "medium" }, "Bodys Reaction", -1)),
              _createElementVNode("p", _hoisted_11, _toDisplayString(log.value.bodys_reaction), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "medium" }, "Additional Notes", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(log.value.additional_notes), 1)
            ])
          ]),
          _createVNode(EditExposureLogForm, {
            onLogEdited: logEdited,
            onHideForm: toggleEditExposureLogForm,
            dishId: dishId.value,
            logId: _unref(log_id),
            show: showEditExposureLogForm.value,
            date: log.value.date,
            anxiety_level: log.value.anxiety_level,
            taste: log.value.taste,
            bodys_reaction: log.value.bodys_reaction,
            additional_notes: log.value.additional_notes
          }, null, 8, ["dishId", "logId", "show", "date", "anxiety_level", "taste", "bodys_reaction", "additional_notes"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14))
            : _createCommentVNode("", true),
          (!log.value && fetchError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", null, _toDisplayString(fetchError.value), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchExposureLog(_ctx.id)))
                }, "Retry")
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})